import fetch from './fetch'

export default {
    getUserReports (payload) {
        const request = fetch({
          url: '/userreport',
          method: 'get',
          data: {},
          payload
        })
        return request.call()
    }
}



// WEBPACK FOOTER //
// ./src/api/userreport.js